import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import "react-quill/dist/quill.snow.css"
import { Link, useNavigate } from "react-router-dom"
import { Form, Table, Select, DatePicker, TimePicker, Typography } from "antd"
import { Container, Row, Button, Col } from "reactstrap"
import ReactQuill from "react-quill"
import Breadcrumb from "../../../components/Common/Breadcrumb"
import dayjs from "dayjs"
import { getTerms, updateTerm } from "store/resources/action"
import { useDispatch, useSelector } from "react-redux"
const { Title, Text } = Typography
//i18n
import { withTranslation } from "react-i18next"
const { Option } = Select
const TermsConditions = props => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading, termsData } = useSelector(state => state.ResourcesReducer)
  const [value, setValue] = useState(termsData.details)

  const handleChange = content => {
    setValue(content)
  }

  useEffect(() => {
    dispatch(getTerms())
  }, [])

  useEffect(() => {
    if (termsData.details) {
      setValue(termsData.details)
    }
  }, [termsData.details])

  const handleSaveChanges = () => {
    const payload = {
      details: value,
    }
    dispatch(updateTerm(payload))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb breadcrumbItem="Terms Conditions" />
          <Row>
            <Col>
              <Title level={3}>Terms Condition</Title>
            </Col>
          </Row>
          <Row>
            <Col>
              <ReactQuill
                value={value}
                onChange={handleChange}
                // theme="snow"
                modules={{ toolbar: true }}
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Button
                className="bg-primary text-white"
                style={{
                  float: "right",
                }}
                onClick={handleSaveChanges}
                disabled={loading}
              >
                Save Changes
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

TermsConditions.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(TermsConditions)
